<div class="settings">
  <h2 class="title">Alterar dados</h2>
  <br />
  <app-user-form *ngIf="user" [user]="user"></app-user-form>
  <br />
  <h2 class="title">Alterar senha</h2>
  <app-password-update *ngIf="user" [user]="user"></app-password-update>
</div>
